import { render } from "./WinPopLayout.vue?vue&type=template&id=6dd2e627&scoped=true"
import script from "./WinPopLayout.vue?vue&type=script&lang=js"
export * from "./WinPopLayout.vue?vue&type=script&lang=js"

import "./WinPopLayout.vue?vue&type=style&index=0&id=6dd2e627&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd2e627"]])

export default __exports__